import axios from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { __API_URL__ } from "../SERVER_URL";

const useUpdateTrialGeneralNotificationConfigMutation = ({ trialId }) => {
  const queryClient = useQueryClient();
  const token = localStorage.getItem("token");

  return useMutation({
    mutationFn: async (payload) => {
      const res = await axios.patch(
        `${__API_URL__}/api/appointments/trial_general_notification_config/${trialId}/`,
        payload,
        { headers: { Authorization: `Token ${token}` } }
      );
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["trial_general_notification_config", trialId] });
    },
  });
};

export default useUpdateTrialGeneralNotificationConfigMutation;
